import React, { useState } from "react";
import contact1 from "../../assets/img/about/18.png";
import contact2 from "../../assets/img/about/19.png";
import { FiPlus } from "react-icons/fi";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { sendContactQuery } from "../../Utils/SendMail";

function GetInTouch() {
  const [formValues, setFormValues] = useState({
    name: "",
    contact: "",
    email: "",
    message: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { name, contact, email, message } = formValues;

    if (!name || !contact || !email || !message) {
      toast.error("All fields are required", {
        position: "top-center",
      });
    } else {
      sendContactQuery(name, email, contact, message)
        .then((responseMessage) => {
          toast.success(responseMessage, {
            position: "top-center",
            autoClose: 2000,
          });
        })
        .catch((errorMessage) => {
          toast.error(errorMessage, {
            position: "top-center",
            autoClose: 2000,
          });
        });
      // Reset form
      setFormValues({
        name: "",
        contact: "",
        email: "",
        message: "",
      });
    }
  };

  return (
    <>
      <ToastContainer />
      <div className="contact-area pd-top-90 pd-bottom-120">
        <div className="container">
          <div className="row">
            <div
              className="col-lg-6 order-lg-end wow animated fadeInLeft"
              data-wow-duration="1.5s"
              data-wow-delay="0.3s"
            >
              <div
                className="about-thumb-inner ms-xl-5 p-xl-5 pt-4 wow animated fadeInLeft"
                data-wow-duration="1.5s"
                data-wow-delay="0.3s"
              >
                <img className="animate-main-img" src={contact1} alt="img" />
                <img className="main-img m-4" src={contact2} alt="img" />
              </div>
            </div>
            <div
              className="col-lg-6 order-lg-first wow animated fadeInRight"
              data-wow-duration="1.5s"
              data-wow-delay="0.3s"
            >
              <div className="section-title mb-0 mt-5 mt-lg-0">
                <h6 className="sub-title">GET IN TOUCH</h6>
                <h2 className="title">
                  Your Business To <span>Growth</span> Please Touch ?
                </h2>
                <p className="content">
                  At Tech Voyage Lab, we specialize in innovative IT solutions
                  and expert consulting tailored to your business needs. Connect
                  with us to discover how we can help you excel in the digital
                  era.
                </p>

                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="single-input-inner style-border">
                        <input
                          type="text"
                          placeholder="Name Here"
                          name="name"
                          value={formValues.name}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="single-input-inner style-border">
                        <input
                          type="text"
                          placeholder="Contact Here"
                          name="contact"
                          value={formValues.contact}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="single-input-inner style-border">
                        <input
                          type="email"
                          placeholder="Email Here"
                          name="email"
                          value={formValues.email}
                          onChange={handleInputChange}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="single-input-inner style-border">
                        <textarea
                          placeholder="Message"
                          name="message"
                          value={formValues.message}
                          onChange={handleInputChange}
                          required
                        ></textarea>
                      </div>
                    </div>
                    <div className="col-12">
                      <button
                        className="btn btn-border-gray mt-0 getInTouchButton"
                        type="submit"
                      >
                        Contact Us <FiPlus />
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default GetInTouch;
